export default "__VITE_ASSET__CYzx412l__"